import React from 'react';

/* eslint-disable max-len */

export const AnchorMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_115" data-name="Group 115" transform="translate(1379.5 13809)">
        <g id="Group_114" data-name="Group 114" transform="translate(-1412 -13824)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="anchor" transform="translate(-1411.949 -13821.949)">
          <g id="Group_13" data-name="Group 13" transform="translate(41.949 20.949)">
            <rect id="Rectangle_1" data-name="Rectangle 1" width="13" height="13" fill="#ff00f5" opacity="0" />
            <path
              id="anchor_copy"
              data-name="anchor copy"
              d="M1.175,6.685H1.79C2.2,8.636,4.384,9.724,6.4,9.724s4.194-1.09,4.608-3.039h.615a.228.228,0,0,0,.161-.389L10.51,5.023a.228.228,0,0,0-.322,0L8.914,6.3a.228.228,0,0,0,.161.389h.667A3.311,3.311,0,0,1,7.006,8.471V4.862h.988a.228.228,0,0,0,.228-.228v-.76a.228.228,0,0,0-.228-.228H7.006v-.1a1.823,1.823,0,1,0-1.215,0v.1H4.8a.228.228,0,0,0-.228.228v.76a.228.228,0,0,0,.228.228H5.79V8.471A3.315,3.315,0,0,1,3.053,6.685h.667A.228.228,0,0,0,3.882,6.3L2.609,5.023a.228.228,0,0,0-.322,0L1.014,6.3A.228.228,0,0,0,1.175,6.685ZM6.4,1.216a.608.608,0,1,1-.608.608A.608.608,0,0,1,6.4,1.216Z"
              transform="translate(0.078 1.837)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BabyCarriageMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_117" data-name="Group 117" transform="translate(-136.5 -15)">
        <g id="Group_116" data-name="Group 116">
          <g id="Group_114" data-name="Group 114" transform="translate(104)">
            <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
              <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
              <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
                <path
                  id="Path_567-2"
                  data-name="Path 567"
                  d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                  transform="translate(-1748.1 -1197.14)"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="baby-carriage" transform="translate(1.132 1.47)">
          <g id="Group_9" data-name="Group 9" transform="translate(145.868 21.53)">
            <rect id="Rectangle_2" data-name="Rectangle 2" width="12" height="12" fill="#ff00f5" opacity="0" />
          </g>
          <g id="Group_10" data-name="Group 10" transform="translate(146.622 22.87)">
            <path
              id="baby-carriage-2"
              data-name="baby-carriage"
              d="M2.985.326A.788.788,0,0,0,1.872.138,4.678,4.678,0,0,0,0,3.834H5.278ZM10.226,1.91h-.99A1.3,1.3,0,0,0,7.917,3.193V4.475H0A3.514,3.514,0,0,0,1.243,7.1a1.6,1.6,0,0,0,.406,3.153A1.626,1.626,0,0,0,3.3,8.645a1.579,1.579,0,0,0-.091-.505,5.484,5.484,0,0,0,2.82,0,1.525,1.525,0,0,0-.091.505A1.65,1.65,0,1,0,7.993,7.1a3.514,3.514,0,0,0,1.243-2.62V3.193h.99a.326.326,0,0,0,.33-.321V2.23A.326.326,0,0,0,10.226,1.91ZM1.649,9.286a.642.642,0,1,1,.66-.641A.653.653,0,0,1,1.649,9.286Zm6.6-.641A.66.66,0,1,1,7.587,8,.653.653,0,0,1,8.247,8.645Z"
              transform="translate(0 0.015)"
              fill="#fdfdfd"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BackpackMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ? props.fillColor : '#c80000'} width="32" height="43.714" viewBox="0 0 32 43.714">
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_118" data-name="Group 118" transform="translate(-240.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(208)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_15" data-name="Group 15" transform="translate(1.143 2.109)">
          <g id="Group_11" data-name="Group 11" transform="translate(249 20.891)">
            <rect id="Rectangle_2" data-name="Rectangle 2" width="14" height="14" transform="translate(-0.143)" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="backpack"
              d="M6.727,6.723H2.564a.7.7,0,0,0-.694.694V8.11H7.421V7.416A.7.7,0,0,0,6.727,6.723ZM1.87,10.886H7.421V8.8H1.87ZM6.727,1.865h0V1.171c0-.664-.718-.694-1.388-.694H3.951c-.67,0-1.388.03-1.388.694v.694h0A2.784,2.784,0,0,0-.212,4.641V9.5a1.392,1.392,0,0,0,1.388,1.388V7.416A1.394,1.394,0,0,1,2.564,6.029H6.727A1.394,1.394,0,0,1,8.115,7.416v3.469A1.392,1.392,0,0,0,9.5,9.5V4.641A2.784,2.784,0,0,0,6.727,1.865ZM3.951,1.171c0-.095-.1,0,0,0H5.339c.1,0,0-.095,0,0v.694H3.951ZM6.727,4.641c0,.095.1,0,0,0H2.564c-.1,0,0,.095,0,0V3.947c0-.095-.1,0,0,0H6.727c.1,0,0-.095,0,0Z"
              transform="translate(251.175 22.087)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BadgeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ? props.fillColor : '#c80000'} width="32" height="43.714" viewBox="0 0 32 43.714">
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_119" data-name="Group 119" transform="translate(-344.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(312)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_16" data-name="Group 16" transform="translate(0.143 2)">
          <g id="Group_12" data-name="Group 12" transform="translate(352.857 21)">
            <rect id="Rectangle_2" data-name="Rectangle 2" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="badge"
              d="M9.751,4.983a1.711,1.711,0,0,0-1.087-1.6A1.741,1.741,0,0,0,8.323,1.46a1.649,1.649,0,0,0-1.878-.348,1.664,1.664,0,0,0-3.139,0,1.649,1.649,0,0,0-1.878.348,1.741,1.741,0,0,0-.341,1.919,1.727,1.727,0,0,0,0,3.208,1.74,1.74,0,0,0,.341,1.919,1.648,1.648,0,0,0,1.878.348,1.664,1.664,0,0,0,3.139,0,1.648,1.648,0,0,0,1.878-.348,1.741,1.741,0,0,0,.341-1.919A1.711,1.711,0,0,0,9.751,4.983Z"
              transform="translate(355.406 22.962)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BaseballBallMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ? props.fillColor : '#c80000'} width="32" height="43.714" viewBox="0 0 32 43.714">
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_120" data-name="Group 120" transform="translate(-448.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(416)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_38" data-name="Group 38" transform="translate(0 2)">
          <g id="Group_17" data-name="Group 17" transform="translate(458 21)">
            <g id="Group_37" data-name="Group 37">
              <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
            </g>
          </g>
          <g>
            <path
              id="baseball-ball"
              d="M7.639,15.482l.6-.292a4.576,4.576,0,0,0,.914,1.28,5.261,5.261,0,0,0,.006-6.507,4.517,4.517,0,0,0-.9,1.251l-.595-.3A5.181,5.181,0,0,1,8.711,9.467a5.076,5.076,0,0,0-7.137,0,5.2,5.2,0,0,1,1.051,1.446l-.595.3a4.531,4.531,0,0,0-.9-1.249,5.257,5.257,0,0,0,0,6.507,4.529,4.529,0,0,0,.918-1.282l.6.292a5.185,5.185,0,0,1-1.068,1.486,5.073,5.073,0,0,0,7.129,0A5.208,5.208,0,0,1,7.639,15.482ZM2.906,14.81,2.274,14.6a4.626,4.626,0,0,0-.012-2.817l.63-.21A5.317,5.317,0,0,1,2.906,14.81ZM7.39,11.585l.63.21a4.641,4.641,0,0,0-.012,2.817l-.632.206A5.316,5.316,0,0,1,7.39,11.585Z"
              transform="translate(459.623 15)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BicycleMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_121" data-name="Group 121" transform="translate(-552.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(520)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_39" data-name="Group 39" transform="translate(0 2)">
          <g id="Group_18" data-name="Group 18" transform="translate(562 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g transform="translate(563 -40)">
            <path
              id="bicycle"
              d="M9.549,66.463a2.312,2.312,0,0,0-.865.163L7.236,64.218A.444.444,0,0,0,6.857,64H5.664a.3.3,0,0,0-.3.308v.308a.3.3,0,0,0,.3.308h.944l.278.462H4.77v-.308a.3.3,0,0,0-.3-.308H2.842a.463.463,0,0,0-.457.47.454.454,0,0,0,.447.453H3.74l-.548.914a2.312,2.312,0,0,0-.8-.145,2.464,2.464,0,0,0-.006,4.926,2.4,2.4,0,0,0,2.31-1.847h.97a.444.444,0,0,0,.38-.219l1.6-2.672.278.463a2.494,2.494,0,0,0-.77,1.817A2.457,2.457,0,0,0,9.516,71.39a2.464,2.464,0,0,0,.033-4.926Zm-6.07,1.42a1.555,1.555,0,0,1,.366.736H3.038ZM2.385,70.466a1.54,1.54,0,0,1,0-3.079,1.444,1.444,0,0,1,.319.036l-.848,1.415a.463.463,0,0,0,.38.7H3.751A1.492,1.492,0,0,1,2.385,70.466Zm3.03-1.847H4.751a2.484,2.484,0,0,0-.79-1.54l.461-.769H6.8L5.415,68.619Zm4.044,1.845A1.521,1.521,0,0,1,8.05,68.987a1.564,1.564,0,0,1,.36-1.063L9.238,69.3a.293.293,0,0,0,.411.1l.253-.162a.314.314,0,0,0,.1-.424L9.17,67.435a1.444,1.444,0,0,1,.37-.048,1.539,1.539,0,0,1-.08,3.077Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BirthdayCakeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_122" data-name="Group 122" transform="translate(-656.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(624)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_40" data-name="Group 40" transform="translate(0 2)">
          <g id="Group_19" data-name="Group 19" transform="translate(666 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="birthday-cake"
              d="M9.081,7.613c-.568,0-.634-.634-1.51-.634s-.949.634-1.515.634-.638-.634-1.515-.634-.957.634-1.51.634c-.571,0-.632-.634-1.515-.634S.57,7.613,0,7.613V6.027a.963.963,0,0,1,.973-.952H1.3V2.22h1.3V5.075h1.3V2.22h1.3V5.075h1.3V2.22h1.3V5.075h.324a.963.963,0,0,1,.973.952Zm0,2.538H0v-1.9c.879,0,.948-.634,1.515-.634s.633.634,1.515.634.957-.634,1.51-.634c.571,0,.632.634,1.515.634S7,7.613,7.571,7.613s.633.634,1.51.634ZM1.946,1.9A.64.64,0,0,1,1.3,1.269C1.3.654,1.946.813,1.946,0c.243,0,.649.585.649,1.11S2.306,1.9,1.946,1.9Zm2.595,0a.64.64,0,0,1-.649-.634C3.892.654,4.54.813,4.54,0c.243,0,.649.585.649,1.11S4.9,1.9,4.54,1.9Zm2.595,0a.64.64,0,0,1-.649-.634c0-.615.649-.456.649-1.269.243,0,.649.585.649,1.11S7.495,1.9,7.135,1.9Z"
              transform="translate(667.791 21.895)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BookmarkMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_123" data-name="Group 123" transform="translate(-760.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(728)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_41" data-name="Group 41" transform="translate(0 2)">
          <g id="Group_20" data-name="Group 20" transform="translate(770 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="bookmark"
              d="M0,8.775V.823A.851.851,0,0,1,.877,0h5.26a.851.851,0,0,1,.877.823V8.775L3.507,6.856Z"
              transform="translate(773.105 23.714)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BooksMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_124" data-name="Group 124" transform="translate(-864.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(832)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_42" data-name="Group 42" transform="translate(0 2)">
          <g id="Group_21" data-name="Group 21" transform="translate(846 28)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" transform="translate(28 -7)" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="books"
              d="M10.614,8.2,8.517.352A.466.466,0,0,0,7.939.018L7.653.094a.511.511,0,0,0-.3.263A4.963,4.963,0,0,1,6.1.694a.509.509,0,0,0-.388-.08L5.429.692a.457.457,0,0,0-.114.057V.592A.591.591,0,0,0,4.725,0H3.543a.591.591,0,0,0-.591.592V1.775H5.315L7.191,9.114a.466.466,0,0,0,.579.335l.285-.077a.511.511,0,0,0,.3-.263,4.968,4.968,0,0,1,1.255-.337.509.509,0,0,0,.388.08l.285-.077a.467.467,0,0,0,.334-.58Zm-2.48-.131-1.7-6.357L7.575,1.4l1.7,6.357ZM0,7.1H2.362V2.367H0ZM1.772,0H.591A.591.591,0,0,0,0,.592V1.775H2.362V.592A.591.591,0,0,0,1.772,0ZM0,8.875a.591.591,0,0,0,.591.592H1.772a.591.591,0,0,0,.591-.592V7.692H0ZM2.953,7.1H5.315V2.367H2.953Zm0,1.775a.591.591,0,0,0,.591.592H4.725a.591.591,0,0,0,.591-.592V7.692H2.953Z"
              transform="translate(876 23)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BuildingMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_125" data-name="Group 125" transform="translate(-968.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(936)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_43" data-name="Group 43" transform="translate(0 2)">
          <g id="Group_22" data-name="Group 22" transform="translate(978 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g transform="translate(980.361 23)">
            <path
              id="building"
              d="M9.146,10.081h-.42V.5a.5.5,0,0,0-.5-.5H1.175a.5.5,0,0,0-.5.5v9.577H.252A.252.252,0,0,0,0,10.333v.42H9.4v-.42A.252.252,0,0,0,9.146,10.081ZM2.685,1.6a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252v.84a.252.252,0,0,1-.252.252H2.937a.252.252,0,0,1-.252-.252Zm0,2.016a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252v.84a.252.252,0,0,1-.252.252H2.937a.252.252,0,0,1-.252-.252ZM3.776,6.721H2.937a.252.252,0,0,1-.252-.252v-.84a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252v.84A.252.252,0,0,1,3.776,6.721Zm1.594,3.36H4.028V8.317a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252ZM6.713,6.469a.252.252,0,0,1-.252.252H5.622a.252.252,0,0,1-.252-.252v-.84a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252Zm0-2.016a.252.252,0,0,1-.252.252H5.622a.252.252,0,0,1-.252-.252v-.84a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252Zm0-2.016a.252.252,0,0,1-.252.252H5.622a.252.252,0,0,1-.252-.252V1.6a.252.252,0,0,1,.252-.252h.839a.252.252,0,0,1,.252.252Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BullseyeArrowMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_126" data-name="Group 126" transform="translate(-1072.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(1040)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_44" data-name="Group 44" transform="translate(0 2)">
          <g id="Group_23" data-name="Group 23" transform="translate(1082 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="bullseye-arrow"
              d="M5.794,9.724l.315.944L4.388,12.388a.456.456,0,1,0,.645.645l1.721-1.721.944.315a.391.391,0,0,0,.4-.094l1.209-1.209a.391.391,0,0,0-.153-.647L8.1,9.324,7.744,8.267A.391.391,0,0,0,7.1,8.115L5.889,9.324a.391.391,0,0,0-.094.4ZM4.366,11.551,5.414,10.5l-.04-.121A2.425,2.425,0,1,0,7.142,12.71a2.4,2.4,0,0,0-.1-.663l-.121-.04L5.87,13.055a1.212,1.212,0,1,1-1.5-1.5ZM9.2,11.288l-.674.674a.992.992,0,0,1-.364.229A3.523,3.523,0,1,1,5.235,9.259a.987.987,0,0,1,.223-.365l.674-.674A4.71,4.71,0,1,0,9.2,11.288Z"
              transform="translate(1083.853 14.853)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CampgroundMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_127" data-name="Group 127" transform="translate(-1176.5 -15)">
        <g id="Group_114" data-name="Group 114" transform="translate(1144)">
          <g id="Component_1_3" data-name="Component 1 – 3" transform="translate(33 15)">
            <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
            <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
              <path
                id="Path_567-2"
                data-name="Path 567"
                d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
                transform="translate(-1748.1 -1197.14)"
                stroke="#fff"
                strokeWidth="2"
              />
            </g>
          </g>
        </g>
        <g id="Group_45" data-name="Group 45" transform="translate(0 2)">
          <g id="Group_24" data-name="Group 24" transform="translate(1186 21)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="campground"
              d="M10.737,7.287h-.425L6.187,1.914l.919-1.2A.251.251,0,0,0,7.045.354L6.6.048a.286.286,0,0,0-.385.058l-.708.922L4.8.106A.286.286,0,0,0,4.413.048L3.968.354a.251.251,0,0,0-.061.364l.919,1.2L.7,7.287H.275A.268.268,0,0,0,0,7.547v.521a.268.268,0,0,0,.275.26H10.737a.268.268,0,0,0,.275-.26V7.547A.268.268,0,0,0,10.737,7.287Zm-5.231-2.6,2,2.6h-4Z"
              transform="translate(1187.424 23.002)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const CarSideMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_128" data-name="Group 128" transform="translate(-32.5 -116)">
        <g id="Component_1_4" data-name="Component 1 – 4" transform="translate(33 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_46" data-name="Group 46">
          <g id="Group_25" data-name="Group 25" transform="translate(42 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" fill="#ff00f5" opacity="0.003" />
          </g>
          <g>
            <path
              id="car-side"
              d="M8.652,34.547H8.4l-1.73-2.165A1.018,1.018,0,0,0,5.872,32H2.47a1.018,1.018,0,0,0-.945.641L.763,34.583A1.016,1.016,0,0,0,0,35.566V37.35a.255.255,0,0,0,.254.255h.763a1.527,1.527,0,1,0,3.054,0H6.107a1.527,1.527,0,1,0,3.054,0h.763a.255.255,0,0,0,.254-.255V36.076A1.528,1.528,0,0,0,8.652,34.547ZM2.545,38.369a.764.764,0,1,1,.763-.764A.765.765,0,0,1,2.545,38.369ZM3.69,34.547H1.86l.611-1.528H3.69Zm.763,0V33.019H5.872l1.221,1.528Zm3.181,3.821A.764.764,0,1,1,8.4,37.6.765.765,0,0,1,7.634,38.369Z"
              transform="translate(43.655 95.787)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ChildMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_129" data-name="Group 129" transform="translate(-136.5 -116)">
        <g id="Component_1_5" data-name="Component 1 – 5" transform="translate(137 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_47" data-name="Group 47">
          <g id="Group_26" data-name="Group 26" transform="translate(146 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="child"
              d="M2.55,1.539a1.53,1.53,0,1,1,1.53,1.539A1.534,1.534,0,0,1,2.55,1.539Zm5.409.029a.677.677,0,0,0-.961,0L5.157,3.421H3L1.161,1.569a.677.677,0,0,0-.961,0,.687.687,0,0,0,0,.968L2.21,4.559v5.7a.682.682,0,0,0,.68.684h.34a.682.682,0,0,0,.68-.684V7.868h.34v2.395a.682.682,0,0,0,.68.684h.34a.682.682,0,0,0,.68-.684v-5.7l2.01-2.023A.687.687,0,0,0,7.959,1.569Z"
              transform="translate(149 126)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DoveMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_130" data-name="Group 130" transform="translate(-240.5 -116)">
        <g id="Component_1_6" data-name="Component 1 – 6" transform="translate(241 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_48" data-name="Group 48">
          <g id="Group_27" data-name="Group 27" transform="translate(250 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="dove"
              d="M4.929,2.918V2.435A4.651,4.651,0,0,1,4,.286.274.274,0,0,0,3.523.143a4.63,4.63,0,0,0-.84,1.485,4.126,4.126,0,0,0,2.246,1.29ZM6.852,1.146A1.375,1.375,0,0,0,5.478,2.521v1.02a4.663,4.663,0,0,1-4-2.777A.274.274,0,0,0,.98.749,4.635,4.635,0,0,0,.533,2.736,4.494,4.494,0,0,0,1.994,5.928a7.014,7.014,0,0,0,.668.563L.192,7.109a.276.276,0,0,0-.163.419,3.091,3.091,0,0,0,2.63,1.31A.552.552,0,0,0,3.038,8.7L4.158,7.74h1.32A2.745,2.745,0,0,0,8.225,4.994V2.245l.549-1.1Zm0,1.65a.275.275,0,1,1,.275-.275A.276.276,0,0,1,6.852,2.8Z"
              transform="translate(252.518 126.952)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DumbbellMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_131" data-name="Group 131" transform="translate(-344.5 -116)">
        <g id="Component_1_7" data-name="Component 1 – 7" transform="translate(345 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_49" data-name="Group 49">
          <g id="Group_28" data-name="Group 28" transform="translate(354 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="dumbbell"
              d="M1.562,32.961H.841a.359.359,0,0,0-.36.36v1.562H.12A.12.12,0,0,0,0,35v.721a.12.12,0,0,0,.12.12H.48v1.562a.359.359,0,0,0,.36.36h.721a.359.359,0,0,0,.36-.36V33.321A.359.359,0,0,0,1.562,32.961Zm7.928,1.922h-.36V33.321a.359.359,0,0,0-.36-.36H8.048a.359.359,0,0,0-.36.36v4.084a.359.359,0,0,0,.36.36h.721a.359.359,0,0,0,.36-.36V35.844h.36a.12.12,0,0,0,.12-.12V35A.12.12,0,0,0,9.489,34.883ZM6.847,32H6.126a.359.359,0,0,0-.36.36v2.523H3.844V32.36a.359.359,0,0,0-.36-.36H2.763a.359.359,0,0,0-.36.36v6.006a.359.359,0,0,0,.36.36h.721a.359.359,0,0,0,.36-.36V35.844H5.766v2.523a.359.359,0,0,0,.36.36h.721a.359.359,0,0,0,.36-.36V32.36A.359.359,0,0,0,6.847,32Z"
              transform="translate(355.857 95.714)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FireAltMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_132" data-name="Group 132" transform="translate(-448.5 -116)">
        <g id="Component_1_8" data-name="Component 1 – 8" transform="translate(449 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_50" data-name="Group 50" transform="translate(-0.071)">
          <g id="Group_29" data-name="Group 29" transform="translate(458 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="13" height="13" transform="translate(0.071)" fill="#ff00f5" opacity="0.001" />
          </g>
          <g>
            <path
              id="fire-alt"
              d="M6.332.939a11.28,11.28,0,0,0-1.1,1.1A14.582,14.582,0,0,0,3.288,0C1.365,1.672,0,3.85,0,5.164A4.307,4.307,0,0,0,4.384,9.389,4.307,4.307,0,0,0,8.767,5.164,7.271,7.271,0,0,0,6.332.939ZM5.951,7.186a2.754,2.754,0,0,1-1.511.443,2.346,2.346,0,0,1-2.561-2.3c0-.708.476-1.332,1.425-2.4.136.146,1.934,2.3,1.934,2.3L6.385,4.006c.081.126.155.248.221.366a2.1,2.1,0,0,1-.654,2.813Z"
              transform="translate(460.421 126.46)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const FlowerDaffodilMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_133" data-name="Group 133" transform="translate(-552.5 -116)">
        <g id="Component_1_9" data-name="Component 1 – 9" transform="translate(553 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_51" data-name="Group 51">
          <g id="Group_30" data-name="Group 30" transform="translate(562 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="flower-daffodil"
              d="M9.419,6.093h-.9a4.634,4.634,0,0,0-3.053,1.1V5.356A1.517,1.517,0,0,0,6.98,2.747,1.517,1.517,0,1,0,4.86.626,1.517,1.517,0,1,0,2.739,2.747,1.517,1.517,0,0,0,4.251,5.356V7.194A4.634,4.634,0,0,0,1.2,6.093H.3a.3.3,0,0,0-.305.32,4.066,4.066,0,0,0,4.254,3.33H5.471a4.066,4.066,0,0,0,4.254-3.33A.3.3,0,0,0,9.419,6.093ZM4.86,3.659a.912.912,0,1,1,.912-.912A.912.912,0,0,1,4.86,3.659Z"
              transform="translate(564.007 125.99)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const GhostMarker = (props) => {
  return (
    <svg
      version="1.1"
      width="32"
      height="43.714"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 32 43.7"
      fill={props.fillColor ? props.fillColor : '#c80000'}
    >
      <g>
        <g id="Component_1_10" transform="translate(657 116)">
          <rect id="Rectangle_40" x="-656.5" y="-116" fill="#C62E2E" fillOpacity="0" width="31" height="42" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)">
            <path
              id="Path_567-2"
              className="st1"
              stroke="#FFFFFF"
              strokeWidth="2"
              d="M-630-101.5c0,1.2-0.2,2.5-0.7,3.6l-7.5,15.6c-0.2,0.4-0.6,0.8-1,1c-0.8,0.5-1.9,0.5-2.8,0 c-0.4-0.2-0.8-0.6-1-1l-7.5-15.6c-0.5-1.1-0.7-2.4-0.7-3.6c0.1-5.8,5-10.4,10.7-10.2C-634.6-111.6-630.1-107.1-630-101.5  L-630-101.5z"
            />
          </g>
        </g>
        <g id="Group_52">
          <g id="Group_31" transform="translate(666 124)">
            <rect id="Rectangle_3" x="-656.3" y="-115.7" className="st2" fill="#FF00F5" fillOpacity="0" width="13" height="13" />
          </g>
          <g>
            <path
              id="ghost"
              className="st3"
              fill="#FFFFFF"
              d="M16.2,9.6c-2.1,0.1-3.7,1.8-3.6,3.9v5.1c0,0.2,0.1,0.3,0.3,0.3c0.1,0,0.2,0,0.2-0.1l0.5-0.4
              c0.1-0.1,0.3-0.1,0.4,0l0.8,0.9c0.1,0.1,0.3,0.1,0.4,0l0.8-0.9c0.1-0.1,0.3-0.1,0.4,0c0,0,0,0,0,0l0.8,0.9c0.1,0.1,0.3,0.1,0.4,0
              l0.8-0.9c0.1-0.1,0.3-0.1,0.4,0l0.5,0.4c0.1,0.1,0.3,0.1,0.4,0c0.1-0.1,0.1-0.1,0.1-0.2v-5.3c0-2.1-1.7-3.7-3.8-3.7
              C16.3,9.6,16.2,9.6,16.2,9.6z M15,13.9c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6
              C15.7,13.6,15.4,13.9,15,13.9C15,13.9,15,13.9,15,13.9z M17.5,13.9c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6
              C18.2,13.6,17.9,13.9,17.5,13.9L17.5,13.9z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const GlassCheersMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_135" data-name="Group 135" transform="translate(-760.5 -116)">
        <g id="Component_1_11" data-name="Component 1 – 11" transform="translate(761 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_53" data-name="Group 53" transform="translate(0 -1)">
          <g id="Group_32" data-name="Group 32" transform="translate(770 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="glass-cheers"
              d="M9.957,6.8a.619.619,0,0,0-.815-.341L8.8,6.6l-.6-1.61a1.865,1.865,0,0,0,.538-2.415L7.381.2a.5.5,0,0,0-.624-.215L4.973.731,3.189-.018A.5.5,0,0,0,2.564.2L1.213,2.576a1.864,1.864,0,0,0,.538,2.413l-.6,1.61L.8,6.454A.62.62,0,0,0-.012,6.8a.127.127,0,0,0,.067.166L2.588,8.026a.123.123,0,0,0,.162-.068.636.636,0,0,0-.337-.827l-.345-.145.615-1.637a1.827,1.827,0,0,0,.2.021,1.819,1.819,0,0,0,1.77-1.348L4.973,2.83l.315,1.192A1.743,1.743,0,0,0,7.262,5.349l.613,1.637-.345.145a.635.635,0,0,0-.337.827.123.123,0,0,0,.162.068L9.89,6.961A.127.127,0,0,0,9.957,6.8ZM4.284,2.506l-1.75-.735.57-1,1.475.62Zm1.377,0L5.366,1.389,6.841.769l.57,1Z"
              transform="translate(772.022 127.057)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HammerMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_136" data-name="Group 136" transform="translate(-864.5 -116)">
        <g id="Component_1_12" data-name="Component 1 – 12" transform="translate(865 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_54" data-name="Group 54">
          <g id="Group_33" data-name="Group 33" transform="translate(874 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="hammer"
              d="M9.988,3.4l-.4-.4a.279.279,0,0,0-.4,0L9,3.2l-.505-.506a1.119,1.119,0,0,0-.286-1.079L7.418.821a2.792,2.792,0,0,0-3.955,0l1.582.793v.329a1.122,1.122,0,0,0,.328.793l.859.861a1.112,1.112,0,0,0,1.077.286l.505.506-.2.2a.281.281,0,0,0,0,.4l.4.4a.279.279,0,0,0,.4,0L9.989,3.794a.281.281,0,0,0,0-.4ZM4.977,3.132A1.7,1.7,0,0,1,4.8,2.922L.347,7.1A1.082,1.082,0,1,0,1.874,8.627L6.036,4.158a1.7,1.7,0,0,1-.2-.165l-.859-.861Z"
              transform="translate(876.246 126)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HandHeartMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_137" data-name="Group 137" transform="translate(-968.5 -116)">
        <g id="Component_1_13" data-name="Component 1 – 13" transform="translate(969 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_55" data-name="Group 55">
          <g id="Group_34" data-name="Group 34" transform="translate(978 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="hand-heart"
              d="M8.188,2.2a.63.63,0,0,0-.628.628V4.242A.157.157,0,0,1,7.4,4.4H7.089a.157.157,0,0,1-.157-.157V1.257a.628.628,0,1,0-1.256,0V4.242A.158.158,0,0,1,5.52,4.4H5.206a.157.157,0,0,1-.157-.157V.628a.628.628,0,1,0-1.256,0V4.242a.157.157,0,0,1-.157.157H3.322a.157.157,0,0,1-.157-.157V1.257a.628.628,0,1,0-1.256,0V5.99l-.463-.638a.785.785,0,1,0-1.27.925L2.641,9.668a.943.943,0,0,0,.761.389H7.28A.941.941,0,0,0,8.2,9.33l.52-2.213a3.957,3.957,0,0,0,.1-.831V2.828A.63.63,0,0,0,8.188,2.2ZM6.954,7.329,5.53,8.731a.239.239,0,0,1-.334,0l-1.425-1.4a.974.974,0,0,1,.073-1.457,1.043,1.043,0,0,1,1.374.094l.145.143.145-.143a1.043,1.043,0,0,1,1.374-.094.976.976,0,0,1,.073,1.457Z"
              transform="translate(979.974 125.674)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HandSparklesMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_138" data-name="Group 138" transform="translate(-1072.5 -116)">
        <g id="Component_1_14" data-name="Component 1 – 14" transform="translate(1073 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_56" data-name="Group 56">
          <g id="Group_35" data-name="Group 35" transform="translate(1082 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="hand-sparkles"
              d="M1.9,3.053h0l.883-.369a.131.131,0,0,0,.066-.107h0a.13.13,0,0,0-.066-.107L1.9,2.1h0l-.368-.888a.118.118,0,0,0-.212,0L.951,2.1h0l-.885.37A.13.13,0,0,0,0,2.576H0a.131.131,0,0,0,.066.107l.884.369h0l.368.889a.118.118,0,0,0,.212,0L1.9,3.053Zm6.5,5.31-.018-.008-.018-.009a.693.693,0,0,1,0-1.237L8.383,7.1,8.4,7.093l.668-.28.279-.671.007-.018.008-.017A.694.694,0,0,1,9.69,5.8c0-.024,0-.048,0-.072V2.576a.57.57,0,1,0-1.141,0V3.865a.143.143,0,0,1-.143.143H8.127a.143.143,0,0,1-.143-.143V1.145a.57.57,0,1,0-1.141,0v2.72a.143.143,0,0,1-.143.143H6.416a.143.143,0,0,1-.143-.143V.573a.57.57,0,1,0-1.141,0V3.865a.143.143,0,0,1-.143.143H4.705a.143.143,0,0,1-.143-.143V1.145a.57.57,0,1,0-1.141,0V5.457L3,4.876a.714.714,0,1,0-1.153.843L4.087,8.806a.856.856,0,0,0,.691.354H8.3a.845.845,0,0,0,.771-.515v0ZM6.234,6.075,5.7,6.3l-.221.533a.071.071,0,0,1-.127,0L5.133,6.3,4.6,6.075a.072.072,0,0,1,0-.128l.531-.222.221-.533a.071.071,0,0,1,.127,0l.222.533.531.222a.072.072,0,0,1,0,.128Zm5.172,1.653a.13.13,0,0,0-.066-.107l-.883-.37h0l-.369-.888a.118.118,0,0,0-.212,0l-.369.888h0l-.885.371a.13.13,0,0,0-.066.107h0a.13.13,0,0,0,.066.106l.883.37h0l.368.887a.118.118,0,0,0,.212,0l.369-.888h0l.883-.37a.13.13,0,0,0,.066-.106h0Z"
              transform="translate(1083 126)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DefaultMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.715" viewBox="0 0 32 43.715" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.046" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_182" data-name="Group 182" transform="translate(1379.5 13809)">
        <g id="Group_114" data-name="Group 114" transform="translate(-1412 -13824)">
          <g id="Component_1_58" data-name="Component 1 – 58" transform="translate(33 15)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HandsHelpingMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_139" data-name="Group 139" transform="translate(-1176.5 -116)">
        <g id="Component_1_15" data-name="Component 1 – 15" transform="translate(1177 116)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_57" data-name="Group 57">
          <g id="Group_36" data-name="Group 36" transform="translate(1186 124)">
            <rect id="Rectangle_3" data-name="Rectangle 3" width="14" height="14" fill="#ff00f5" opacity="0" />
          </g>
          <g id="Group_3" data-name="Group 3" transform="translate(1 24)">
            <path
              id="hands-helping"
              d="M7.886,3.137H5.422v.909a1.167,1.167,0,1,1-2.334,0V2.073l-1.052.633a1.037,1.037,0,0,0-.5.889v.768l-1.3.75a.518.518,0,0,0-.19.709l1.3,2.249a.518.518,0,0,0,.708.19l1.676-.969H5.941A1.039,1.039,0,0,0,6.978,6.253h.259a.518.518,0,0,0,.519-.519V4.7h.13a.388.388,0,0,0,.389-.389V3.527A.388.388,0,0,0,7.886,3.137Zm2.393-.607L8.983.281a.518.518,0,0,0-.708-.19L6.6,1.06H4.943a1.044,1.044,0,0,0-.549.157l-.543.339A.516.516,0,0,0,3.607,2v2.05a.648.648,0,1,0,1.3,0V2.618H7.886a.909.909,0,0,1,.907.909v.463l1.3-.75A.52.52,0,0,0,10.279,2.53Z"
              transform="translate(1187.023 102.979)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

//* *NEEDS TESTING **//

export const HeartBrokenMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_140" data-name="Group 140" transform="translate(-32.5 -217)">
        <g id="Component_1_16" data-name="Component 1 – 16" transform="translate(33 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_59" data-name="Group 59" transform="translate(0 -1)">
          <rect id="Rectangle_4" data-name="Rectangle 4" width="14" height="14" transform="translate(42 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="heart-broken"
              d="M9.326,32.82l-.047-.048a2.616,2.616,0,0,0-3.344-.286l.676,2L4.718,35.72l.946,2.473L2.825,35.411l1.893-1.236L4.154,32.5a2.614,2.614,0,0,0-3.366.27l-.047.046A2.615,2.615,0,0,0,.6,36.34l4.182,4.223a.356.356,0,0,0,.507,0L9.47,36.338A2.613,2.613,0,0,0,9.326,32.82Z"
              transform="translate(44.015 197.987)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HeartMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_141" data-name="Group 141" transform="translate(-136.5 -217)">
        <g id="Component_1_17" data-name="Component 1 – 17" transform="translate(137 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_60" data-name="Group 60" transform="translate(0 -1.007)">
          <rect id="Rectangle_5" data-name="Rectangle 5" width="13" height="13" transform="translate(146 227.007)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="heart"
              d="M8.611,32.543A2.536,2.536,0,0,0,5.13,32.8l-.367.382L4.4,32.8a2.536,2.536,0,0,0-3.481-.256,2.716,2.716,0,0,0-.185,3.91L4.34,40.21a.581.581,0,0,0,.845,0l3.609-3.757a2.714,2.714,0,0,0-.183-3.91Z"
              transform="translate(147.87 197.82)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HikingMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_142" data-name="Group 142" transform="translate(-240.5 -217)">
        <g id="Component_1_18" data-name="Component 1 – 18" transform="translate(241 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_61" data-name="Group 61" transform="translate(0 -2)">
          <rect id="Rectangle_6" data-name="Rectangle 6" width="14" height="14" transform="translate(250 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="hiking"
              d="M1.848,10.788a.731.731,0,0,0,1.419.355l.577-2.307L2.637,7.631l-.79,3.158Zm.34-4.481.94-3.635a.358.358,0,0,0-.272-.435A1.878,1.878,0,0,0,.587,3.544L.01,5.785a.358.358,0,0,0,.272.435l1.452.348A.376.376,0,0,0,2.188,6.308ZM8.406,3.655H8.04a.365.365,0,0,0-.366.366v.366H6.881L5.812,3.318a1.343,1.343,0,0,0-2.252.624L2.945,6.4a.731.731,0,0,0,.192.694L5.116,9.075v1.89a.731.731,0,1,0,1.462,0V9.075A1.452,1.452,0,0,0,6.15,8.042L5.08,6.972c0-.011.011-.02.014-.032l.454-1.818.512.512a.731.731,0,0,0,.517.214h1.1v5.483a.365.365,0,0,0,.366.366h.366a.365.365,0,0,0,.366-.366V4.021A.365.365,0,0,0,8.406,3.655ZM5.481,2.193a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.481,2.193Z"
              transform="translate(252.002 228)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HomeHeartMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_143" data-name="Group 143" transform="translate(-344.5 -217)">
        <g id="Component_1_19" data-name="Component 1 – 19" transform="translate(345 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_62" data-name="Group 62" transform="translate(0 -2)">
          <rect id="Rectangle_7" data-name="Rectangle 7" width="13" height="13" transform="translate(354 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="home-heart"
              d="M9.4,3.958,8.424,3.1V.823A.267.267,0,0,0,8.157.557H7.091a.267.267,0,0,0-.267.266v.86L5.136.2a.666.666,0,0,0-.891,0L-.021,3.958a.266.266,0,0,0-.02.376l.357.4a.267.267,0,0,0,.377.02L4.515,1.384a.269.269,0,0,1,.353,0L8.689,4.751a.267.267,0,0,0,.377-.02l.357-.4A.268.268,0,0,0,9.4,3.958ZM4.692,1.939C.441,5.684.959,5.2.959,5.2V8.28a.267.267,0,0,0,.267.266H8.157a.267.267,0,0,0,.267-.266V5.2S8.956,5.693,4.692,1.939ZM6.268,6.253,4.857,7.677a.233.233,0,0,1-.33,0L3.115,6.253A1,1,0,1,1,4.547,4.866l.143.145.143-.145A1,1,0,1,1,6.268,6.253Z"
              transform="translate(355.966 229.197)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HomeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_144" data-name="Group 144" transform="translate(-448.5 -217)">
        <g id="Component_1_20" data-name="Component 1 – 20" transform="translate(449 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_63" data-name="Group 63" transform="translate(0 -2)">
          <rect id="Rectangle_8" data-name="Rectangle 8" width="13" height="13" transform="translate(458 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="home"
              d="M8.346,37.07v2.413a.4.4,0,0,1-.408.4H5.968a.2.2,0,0,1-.2-.2V37.8a.2.2,0,0,0-.2-.2H4.338a.2.2,0,0,0-.2.2v1.886a.2.2,0,0,1-.2.2H1.96a.4.4,0,0,1-.408-.4V37.07a.2.2,0,0,1,.075-.157L4.82,34.307a.208.208,0,0,1,.26,0l3.193,2.606A.205.205,0,0,1,8.346,37.07Zm1.42-1.025-1.42-1.16V32.553a.2.2,0,0,0-.2-.2H7.191a.2.2,0,0,0-.2.2v1.222l-1.52-1.241a.82.82,0,0,0-1.036,0l-4.3,3.51a.2.2,0,0,0-.027.285l.433.522a.206.206,0,0,0,.287.027L4.82,33.617a.208.208,0,0,1,.26,0l3.994,3.261a.206.206,0,0,0,.287-.027l.433-.522A.2.2,0,0,0,9.766,36.045Z"
              transform="translate(459.798 197.31)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const HospitalMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_145" data-name="Group 145" transform="translate(-552.5 -217)">
        <g id="Component_1_21" data-name="Component 1 – 21" transform="translate(553 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_64" data-name="Group 64" transform="translate(0 -2)">
          <rect id="Rectangle_9" data-name="Rectangle 9" width="13" height="13" transform="translate(562 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="hospital"
              d="M7.715,8.472v.344H0V8.472a.207.207,0,0,1,.207-.207H.551v-6.2a.413.413,0,0,1,.413-.413H2.48V.413A.413.413,0,0,1,2.893,0H4.822a.413.413,0,0,1,.413.413v1.24H6.75a.413.413,0,0,1,.413.413v6.2h.344A.207.207,0,0,1,7.715,8.472ZM5.3,3.306H4.615a.207.207,0,0,0-.207.207V4.2a.207.207,0,0,0,.207.207H5.3A.207.207,0,0,0,5.511,4.2V3.513A.207.207,0,0,0,5.3,3.306Zm-2.893,1.1H3.1A.207.207,0,0,0,3.306,4.2V3.513A.207.207,0,0,0,3.1,3.306H2.411a.207.207,0,0,0-.207.207V4.2A.207.207,0,0,0,2.411,4.408ZM4.2,6.613H3.513a.207.207,0,0,0-.207.207V8.266h1.1V6.819A.207.207,0,0,0,4.2,6.613ZM5.3,4.96H4.615a.207.207,0,0,0-.207.207v.689a.207.207,0,0,0,.207.207H5.3a.207.207,0,0,0,.207-.207V5.166A.207.207,0,0,0,5.3,4.96Zm-2,.207A.207.207,0,0,0,3.1,4.96H2.411a.207.207,0,0,0-.207.207v.689a.207.207,0,0,0,.207.207H3.1a.207.207,0,0,0,.207-.207ZM3.134,1.653h.448V2.1a.1.1,0,0,0,.1.1H4.03a.1.1,0,0,0,.1-.1V1.653h.448a.1.1,0,0,0,.1-.1V1.205a.1.1,0,0,0-.1-.1H4.133V.654a.1.1,0,0,0-.1-.1H3.685a.1.1,0,0,0-.1.1V1.1H3.134a.1.1,0,0,0-.1.1V1.55A.1.1,0,0,0,3.134,1.653Z"
              transform="translate(564.786 228.857)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const KeyMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ? props.fillColor : '#c80000'} width="32" height="43.714" viewBox="0 0 32 43.714">
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_146" data-name="Group 146" transform="translate(-656.5 -217)">
        <g id="Component_1_22" data-name="Component 1 – 22" transform="translate(657 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_65" data-name="Group 65" transform="translate(0 -2)">
          <rect id="Rectangle_10" data-name="Rectangle 10" width="13" height="13" transform="translate(666 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="key"
              d="M9.162,3.15A3.151,3.151,0,0,1,5.425,6.244L5,6.728a.429.429,0,0,1-.321.144H4.009v.716a.429.429,0,0,1-.429.429H2.863v.716a.429.429,0,0,1-.429.429h-2A.429.429,0,0,1,0,8.733v-1.4a.43.43,0,0,1,.126-.3l2.9-2.9A3.15,3.15,0,1,1,9.162,3.15Zm-3.15-.859a.859.859,0,1,0,.859-.859A.859.859,0,0,0,6.013,2.291Z"
              transform="translate(668.14 228.857)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MountainMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="42" viewBox="0 0 31 42" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="-0.5" y="1.669" width="32" height="42.046" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="clip-marker-background_1">
          <rect width="31" height="42" />
        </clipPath>
      </defs>
      <g id="marker-background_1" data-name="marker-background – 1" clipPath="url(#clip-marker-background_1)">
        <g id="Component_1_2" data-name="Component 1 – 2">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.6 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_71" data-name="Group 71" transform="translate(-34 -323)">
          <rect id="Rectangle_16" data-name="Rectangle 16" width="15" height="15" transform="translate(42 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="mountain"
              d="M10.842,7.2,5.923.229a.577.577,0,0,0-.92,0L.084,7.2a.46.46,0,0,0-.02.508.557.557,0,0,0,.48.259h9.839a.557.557,0,0,0,.48-.259.46.46,0,0,0-.02-.508ZM5.463,1.419,6.921,3.485H5.463l-1.093,1-.65-.592Z"
              transform="translate(44.003 332)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const LandmarkMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_147" data-name="Group 147" transform="translate(-760.5 -217)">
        <g id="Component_1_23" data-name="Component 1 – 23" transform="translate(761 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_66" data-name="Group 66" transform="translate(0 -3)">
          <rect id="Rectangle_11" data-name="Rectangle 11" width="14" height="14" transform="translate(770 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="landmark"
              d="M9.336,1.714,4.974.038a.6.6,0,0,0-.418,0L.193,1.714A.3.3,0,0,0,0,1.993V2.68a.3.3,0,0,0,.3.3H9.231a.3.3,0,0,0,.3-.3V1.993A.3.3,0,0,0,9.336,1.714ZM1.191,3.574V6.551h-.3a.3.3,0,0,0-.3.3v.893H8.934V6.849a.3.3,0,0,0-.3-.3h-.3V3.574H7.147V6.551H5.36V3.574H4.169V6.551H2.382V3.574Zm8.04,4.765H.3a.3.3,0,0,0-.3.3v.6a.3.3,0,0,0,.3.3H9.231a.3.3,0,0,0,.3-.3v-.6A.3.3,0,0,0,9.231,8.338Z"
              transform="translate(772 229)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const LightbulbMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_148" data-name="Group 148" transform="translate(-864.5 -217)">
        <g id="Component_1_24" data-name="Component 1 – 24" transform="translate(865 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_67" data-name="Group 67" transform="translate(0 -1.358)">
          <rect id="Rectangle_12" data-name="Rectangle 12" width="13" height="13" transform="translate(874 227.358)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="lightbulb"
              d="M2.055,9.662a.678.678,0,0,0,.115.376l.366.546a.685.685,0,0,0,.57.3h1.32a.685.685,0,0,0,.57-.3l.366-.546a.677.677,0,0,0,.115-.376V8.846H2.054v.816ZM0,3.742A3.71,3.71,0,0,0,.932,6.2,6.1,6.1,0,0,1,2.049,8.149l0,.017H5.479l0-.017A6.1,6.1,0,0,1,6.6,6.2,3.71,3.71,0,0,0,7.53,3.742,3.754,3.754,0,0,0,3.753,0,3.738,3.738,0,0,0,0,3.742Zm3.765-1.7a1.708,1.708,0,0,0-1.711,1.7.342.342,0,0,1-.685,0,2.392,2.392,0,0,1,2.4-2.382.34.34,0,1,1,0,.681Z"
              transform="translate(876.862 227.955)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MapPinMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_149" data-name="Group 149" transform="translate(-968.5 -217)">
        <g id="Component_1_25" data-name="Component 1 – 25" transform="translate(969 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_68" data-name="Group 68" transform="translate(0 -1)">
          <rect id="Rectangle_13" data-name="Rectangle 13" width="13" height="13" transform="translate(978 227)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="map-pin"
              d="M2.31,6.536V9.767l.454.681a.248.248,0,0,0,.412,0l.454-.681V6.536a3.482,3.482,0,0,1-1.32,0ZM2.969,0A2.969,2.969,0,1,0,5.939,2.969,2.969,2.969,0,0,0,2.969,0Zm0,1.567a1.4,1.4,0,0,0-1.4,1.4.247.247,0,0,1-.495,0,1.9,1.9,0,0,1,1.9-1.9.247.247,0,0,1,0,.495Z"
              transform="translate(981.714 227.929)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MedalMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_150" data-name="Group 150" transform="translate(-1072.5 -217)">
        <g id="Component_1_26" data-name="Component 1 – 26" transform="translate(1073 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_69" data-name="Group 69" transform="translate(0 -1.102)">
          <rect id="Rectangle_14" data-name="Rectangle 14" width="13" height="13" transform="translate(1082 227.102)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="medal"
              d="M3.854,2.252,2.664.268A.551.551,0,0,0,2.191,0H.277A.276.276,0,0,0,.051.434L1.967,3.171A3.564,3.564,0,0,1,3.854,2.252ZM8.542,0H6.628a.551.551,0,0,0-.473.268L4.965,2.252a3.565,3.565,0,0,1,1.887.919L8.768.434A.276.276,0,0,0,8.542,0ZM4.41,2.756A3.031,3.031,0,1,0,7.441,5.787,3.031,3.031,0,0,0,4.41,2.756ZM6,5.464,5.35,6.1,5.5,7a.2.2,0,0,1-.287.208L4.41,6.783,3.6,7.208A.2.2,0,0,1,3.315,7l.154-.9-.653-.637a.2.2,0,0,1,.109-.337l.9-.132.4-.818a.2.2,0,0,1,.355,0l.4.818.9.132A.2.2,0,0,1,6,5.464Z"
              transform="translate(1084.175 229.175)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MoonStarsMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_151" data-name="Group 151" transform="translate(-1176.5 -217)">
        <g id="Component_1_27" data-name="Component 1 – 27" transform="translate(1177 217)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_70" data-name="Group 70" transform="translate(0 -2)">
          <rect id="Rectangle_15" data-name="Rectangle 15" width="14" height="14" transform="translate(1186 227)" fill="#ff00f5" opacity="0" />
          <g id="Group_4" data-name="Group 4" transform="translate(1 24)">
            <path
              id="moon-stars"
              d="M6.594,8.464A2.985,2.985,0,0,1,4.561,2.936.179.179,0,0,0,4.506,2.6,3.812,3.812,0,1,0,6.765,8.752a.178.178,0,0,0-.171-.288Zm-.56-6.558.318-.635L6.987.953,6.352.635,6.034,0,5.717.635,5.082.953l.635.318ZM9.105,3.6l-.53-1.058L8.045,3.6l-1.058.53,1.058.53.53,1.058.53-1.058,1.058-.53Z"
              transform="translate(1187 205)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MugHotMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_153" data-name="Group 153" transform="translate(-136.5 -322)">
        <g id="Component_1_29" data-name="Component 1 – 29" transform="translate(137 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_72" data-name="Group 72">
          <g id="Group_93" data-name="Group 93">
            <rect id="Rectangle_17" data-name="Rectangle 17" width="14" height="14" transform="translate(146 330)" fill="#ff00f5" opacity="0" />
            <path
              id="mug-hot"
              d="M2.27,2.616a.29.29,0,0,0,.286.241H2.85a.289.289,0,0,0,.291-.321A2.334,2.334,0,0,0,2.487,1.2,1.693,1.693,0,0,1,2.016.246.288.288,0,0,0,1.729,0H1.436a.291.291,0,0,0-.291.321A2.6,2.6,0,0,0,1.87,1.829,1.45,1.45,0,0,1,2.27,2.616Zm2,0a.29.29,0,0,0,.286.241H4.85a.289.289,0,0,0,.291-.321A2.334,2.334,0,0,0,4.487,1.2,1.693,1.693,0,0,1,4.016.246.288.288,0,0,0,3.728,0H3.436a.29.29,0,0,0-.291.321A2.6,2.6,0,0,0,3.87,1.829,1.45,1.45,0,0,1,4.27,2.616Zm2.873.812H.571A.571.571,0,0,0,0,4V7.428A1.715,1.715,0,0,0,1.714,9.143H5.143A1.715,1.715,0,0,0,6.857,7.428h.286a2,2,0,0,0,0-4Zm0,2.857H6.857V4.571h.286a.857.857,0,0,1,0,1.714Z"
              transform="translate(149 332)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const MusicMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={props.fillColor ? props.fillColor : '#c80000'} width="32" height="43.714" viewBox="0 0 32 43.714">
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_154" data-name="Group 154" transform="translate(-240.5 -322)">
        <g id="Component_1_30" data-name="Component 1 – 30" transform="translate(241 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <path
            id="Path_567-2"
            data-name="Path 567"
            d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
            transform="translate(-1748.1 -1197.14)"
            stroke="#fff"
            strokeWidth="2"
          />
        </g>
        <g id="Group_73" data-name="Group 73" transform="translate(-1)">
          <rect id="Rectangle_18" data-name="Rectangle 18" width="14" height="14" transform="translate(250 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="music"
              d="M9.826.605a.614.614,0,0,0-.8-.586L2.887,1.834a.614.614,0,0,0-.43.585V7.436a2.655,2.655,0,0,0-.614-.075C.825,7.361,0,7.911,0,8.589S.825,9.817,1.842,9.817s1.842-.55,1.842-1.228V4.1L8.6,2.664V6.208a2.655,2.655,0,0,0-.614-.075c-1.018,0-1.842.55-1.842,1.228s.825,1.228,1.842,1.228,1.842-.55,1.842-1.228V.605Z"
              transform="translate(252 332.009)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const NotesMedicalMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_155" data-name="Group 155" transform="translate(-344.5 -322)">
        <g id="Component_1_31" data-name="Component 1 – 31" transform="translate(345 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_74" data-name="Group 74" transform="translate(0 -1)">
          <rect id="Rectangle_19" data-name="Rectangle 19" width="14" height="14" transform="translate(354 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="notes-medical"
              d="M6.646,1.267H5.064a1.266,1.266,0,1,0-2.532,0H.949A.95.95,0,0,0,0,2.217V9.186a.95.95,0,0,0,.949.95h5.7a.95.95,0,0,0,.949-.95V2.217A.95.95,0,0,0,6.646,1.267ZM3.8.792a.475.475,0,1,1-.475.475A.474.474,0,0,1,3.8.792ZM5.7,6.811a.159.159,0,0,1-.158.158H4.431V8.078a.159.159,0,0,1-.158.158H3.323a.159.159,0,0,1-.158-.158V6.969H2.057A.159.159,0,0,1,1.9,6.811V5.86A.159.159,0,0,1,2.057,5.7H3.165V4.593a.159.159,0,0,1,.158-.158h.949a.159.159,0,0,1,.158.158V5.7H5.539A.159.159,0,0,1,5.7,5.86Zm0-3.8a.159.159,0,0,1-.158.158H2.057A.159.159,0,0,1,1.9,3.009V2.693a.159.159,0,0,1,.158-.158H5.539a.159.159,0,0,1,.158.158Z"
              transform="translate(357 332)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PaletteMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_156" data-name="Group 156" transform="translate(-448.5 -322)">
        <g id="Component_1_32" data-name="Component 1 – 32" transform="translate(449 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_75" data-name="Group 75" transform="translate(-1 -1)">
          <rect id="Rectangle_20" data-name="Rectangle 20" width="14" height="14" transform="translate(458 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="palette"
              d="M4.193.068A5.212,5.212,0,0,0,.118,4.128c-.757,3.827,2.7,6.68,5.3,6.277a1.292,1.292,0,0,0,.87-1.877A1.385,1.385,0,0,1,7.531,6.515H9.162a1.339,1.339,0,0,0,1.328-1.336A5.243,5.243,0,0,0,4.193.068ZM1.977,6.515a.655.655,0,1,1,.655-.655A.654.654,0,0,1,1.977,6.515ZM2.632,3.9a.655.655,0,1,1,.655-.655A.654.654,0,0,1,2.632,3.9Zm2.62-1.31a.655.655,0,1,1,.655-.655A.654.654,0,0,1,5.251,2.585ZM7.871,3.9a.655.655,0,1,1,.655-.655A.654.654,0,0,1,7.871,3.9Z"
              transform="translate(460.112 332.035)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PawMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_157" data-name="Group 157" transform="translate(-552.5 -322)">
        <g id="Component_1_33" data-name="Component 1 – 33" transform="translate(553 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_76" data-name="Group 76">
          <rect id="Rectangle_21" data-name="Rectangle 21" width="14" height="14" transform="translate(562 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="paw"
              d="M4.784,35.6C3.3,35.6,1.19,37.911,1.19,39.368c0,.656.5,1.048,1.343,1.048.914,0,1.518-.472,2.251-.472s1.345.472,2.251.472c.841,0,1.343-.392,1.343-1.048C8.378,37.911,6.271,35.6,4.784,35.6Zm-2.757-.237a1.216,1.216,0,0,0-1.34-.942A1.066,1.066,0,0,0,.054,35.84a1.216,1.216,0,0,0,1.34.942A1.066,1.066,0,0,0,2.028,35.366Zm1.586-.391c.579-.153.869-.939.647-1.755s-.871-1.354-1.45-1.2-.869.939-.647,1.755S3.034,35.128,3.613,34.975Zm5.267-.552a1.216,1.216,0,0,0-1.34.942,1.066,1.066,0,0,0,.634,1.416,1.216,1.216,0,0,0,1.34-.942A1.066,1.066,0,0,0,8.881,34.423Zm-2.925.552c.579.153,1.228-.384,1.45-1.2s-.068-1.6-.647-1.755-1.228.384-1.45,1.2S5.376,34.822,5.955,34.975Z"
              transform="translate(564.209 300.007)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PlanetMoonMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_158" data-name="Group 158" transform="translate(-656.5 -322)">
        <g id="Component_1_34" data-name="Component 1 – 34" transform="translate(657 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_77" data-name="Group 77" transform="translate(0 -1)">
          <rect id="Rectangle_22" data-name="Rectangle 22" width="14" height="14" transform="translate(666 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="planet-moon"
              d="M8.913,0a1.107,1.107,0,1,0,1.114,1.107A1.111,1.111,0,0,0,8.913,0ZM3.9,1.107A3.875,3.875,0,1,0,7.8,4.982,3.887,3.887,0,0,0,3.9,1.107ZM5.57,5.828a1.1,1.1,0,0,1-.118.5l-.7,1.4a.5.5,0,0,1-.364.267Q4.3,8,4.206,8.011a.28.28,0,0,1-.215-.071A.277.277,0,0,1,3.9,7.734c0-.406,0-1.091,0-1.091a.555.555,0,0,1-.557-.554V5.536l-.951-.945A.559.559,0,0,0,2,4.429H1.562a.5.5,0,0,1-.452-.7A3.066,3.066,0,0,1,3.9,1.938h.078a.494.494,0,0,1,.479.494,1.1,1.1,0,0,1-.187.614L3.4,4.039a.551.551,0,0,0,.027.754.652.652,0,0,0,.459.189H5.013a.555.555,0,0,1,.557.554Z"
              transform="translate(668 333)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PrayingHandsMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_159" data-name="Group 159" transform="translate(-760.5 -322)">
        <g id="Component_1_35" data-name="Component 1 – 35" transform="translate(761 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_78" data-name="Group 78" transform="translate(0 -1)">
          <rect id="Rectangle_23" data-name="Rectangle 23" width="14" height="14" transform="translate(770 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="praying-hands"
              d="M4.229,2.994a.5.5,0,0,0-.5.5V4.746a.249.249,0,1,1-.5,0v-1.2a1.507,1.507,0,0,1,.213-.773L4.655.749A.5.5,0,0,0,4.485.062a.492.492,0,0,0-.658.144s-.01,0-.012.008L1.992,2.965a1.5,1.5,0,0,0-.251.833V5.053l-1.4.47A.5.5,0,0,0,0,6V7.5A.5.5,0,0,0,.5,8a.5.5,0,0,0,.125-.016l2.786-.729A1.834,1.834,0,0,0,4.726,5.5v-2A.5.5,0,0,0,4.229,2.994ZM9.61,5.524l-1.4-.47V3.8a1.5,1.5,0,0,0-.251-.833L6.135.215s-.009,0-.012-.008A.492.492,0,0,0,5.465.063.5.5,0,0,0,5.295.75L6.5,2.777a1.507,1.507,0,0,1,.213.773v1.2a.249.249,0,1,1-.5,0V3.5a.5.5,0,1,0-.995,0v2A1.834,1.834,0,0,0,6.541,7.256l2.786.729A.5.5,0,0,0,9.452,8a.5.5,0,0,0,.5-.5V6A.5.5,0,0,0,9.61,5.524Z"
              transform="translate(772 333.009)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RainbowMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_160" data-name="Group 160" transform="translate(-864.5 -322)">
        <g id="Component_1_36" data-name="Component 1 – 36" transform="translate(865 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_79" data-name="Group 79" transform="translate(1 -0.136)">
          <rect id="Rectangle_24" data-name="Rectangle 24" width="12" height="12" transform="translate(874 330.135)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="rainbow"
              d="M4.845,32.043A5.336,5.336,0,0,0,0,37.437v2.426a.29.29,0,0,0,.289.29H.867a.29.29,0,0,0,.289-.29V37.252a4.056,4.056,0,0,1,4.578-4.027,4.152,4.152,0,0,1,3.513,4.169v2.47a.29.29,0,0,0,.289.29h.578a.29.29,0,0,0,.289-.29V37.252A5.214,5.214,0,0,0,4.845,32.043Zm-.1,1.757a3.559,3.559,0,0,0-3.011,3.574v2.49a.29.29,0,0,0,.289.29H2.6a.29.29,0,0,0,.289-.29V37.252a2.319,2.319,0,0,1,2.543-2.31,2.387,2.387,0,0,1,2.08,2.413v2.508a.29.29,0,0,0,.289.29H8.38a.29.29,0,0,0,.289-.29V37.252A3.477,3.477,0,0,0,4.744,33.8Zm.112,1.746a1.786,1.786,0,0,0-1.389,1.775v2.542a.29.29,0,0,0,.289.29h.578a.29.29,0,0,0,.289-.29V37.252a.578.578,0,1,1,1.156,0v2.611a.29.29,0,0,0,.289.29h.578a.29.29,0,0,0,.289-.29V37.252A1.737,1.737,0,0,0,4.856,35.546Z"
              transform="translate(874.887 299.75)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const RocketLaunchMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_161" data-name="Group 161" transform="translate(-968.5 -322)">
        <g id="Component_1_37" data-name="Component 1 – 37" transform="translate(969 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_80" data-name="Group 80">
          <rect id="Rectangle_25" data-name="Rectangle 25" width="13" height="13" transform="translate(978 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="rocket"
              d="M10.183.384A.32.32,0,0,0,9.938.139,7.3,7.3,0,0,0,8.278,0a4.8,4.8,0,0,0-4.25,2.574h-2.1a.965.965,0,0,0-.863.533L.076,5.093a.482.482,0,0,0,.432.7H2.421c-.119.257-.239.513-.362.758a.321.321,0,0,0,.06.372L3.4,8.2a.321.321,0,0,0,.372.06c.245-.123.5-.241.758-.36V9.813a.484.484,0,0,0,.7.432l1.985-.993a.963.963,0,0,0,.533-.863V6.29A4.814,4.814,0,0,0,10.32,2.045,7.181,7.181,0,0,0,10.183.384ZM8.069,3.217a.965.965,0,1,1,.965-.965A.966.966,0,0,1,8.069,3.217Z"
              transform="translate(979.198 331.857)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SeedlingMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_162" data-name="Group 162" transform="translate(-1072.5 -322)">
        <g id="Component_1_38" data-name="Component 1 – 38" transform="translate(1073 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_81" data-name="Group 81">
          <rect id="Rectangle_26" data-name="Rectangle 26" width="14" height="14" transform="translate(1082 330)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="seedling"
              d="M1.246,33.253H0A4.375,4.375,0,0,0,4.363,37.64v2.82a.313.313,0,0,0,.312.313H5.3a.313.313,0,0,0,.312-.313V37.64A4.375,4.375,0,0,0,1.246,33.253ZM8.725,32a4.355,4.355,0,0,0-3.812,2.256,5.029,5.029,0,0,1,1.149,2.107A4.379,4.379,0,0,0,9.972,32Z"
              transform="translate(1084 300.862)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ShoePrintsMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_163" data-name="Group 163" transform="translate(-1176.5 -322)">
        <g id="Component_1_39" data-name="Component 1 – 39" transform="translate(1177 322)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_82" data-name="Group 82">
          <rect id="Rectangle_27" data-name="Rectangle 27" width="14" height="14" transform="translate(1186 330)" fill="#ff00f5" opacity="0" />
          <g id="Group_5" data-name="Group 5" transform="translate(1 27)">
            <path
              id="shoe-prints"
              d="M3.256,2.714H3.8V.545H3.256a1.085,1.085,0,1,0,0,2.17ZM0,7.053A1.085,1.085,0,0,0,1.085,8.138h.543V5.969H1.085A1.085,1.085,0,0,0,0,7.053Zm5.722-2.17a3.469,3.469,0,0,0-1.776.542,2.592,2.592,0,0,1-1.776.542v2.17l.976.271a6.932,6.932,0,0,0,1.362.255,5.9,5.9,0,0,0,1.655-.105c1.856-.4,2.519-1.281,2.519-2.048,0-1.085-1.427-1.627-2.96-1.627ZM8.333.124A5.9,5.9,0,0,0,6.678.019,6.944,6.944,0,0,0,5.316.274L4.341.545v2.17a2.592,2.592,0,0,1,1.776.542A3.469,3.469,0,0,0,7.893,3.8c1.532,0,2.96-.542,2.96-1.627,0-.766-.663-1.649-2.519-2.048Z"
              transform="translate(1186 305.998)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UserMdMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_164" data-name="Group 164" transform="translate(-1176.5 -425)">
        <g id="Component_1_51" data-name="Component 1 – 51" transform="translate(1177 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_105" data-name="Group 105">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(1186 433)" fill="#ff00f5" opacity="0" />
          <g id="Group_6" data-name="Group 6" transform="translate(1188.783 434.856)">
            <path
              id="user-md"
              d="M3.889,4.445A2.223,2.223,0,1,0,1.667,2.223,2.222,2.222,0,0,0,3.889,4.445ZM1.806,7.362a.417.417,0,1,0,.417-.417A.416.416,0,0,0,1.806,7.362ZM5.556,5.011v.851A1.391,1.391,0,0,1,6.668,7.223v.724a.279.279,0,0,1-.224.273l-.559.111a.138.138,0,0,1-.163-.109l-.054-.273a.137.137,0,0,1,.109-.163l.335-.068V7.223a.834.834,0,1,0-1.667.033V7.72l.335.068a.141.141,0,0,1,.109.163l-.054.273a.141.141,0,0,1-.163.109L4.131,8.26a.277.277,0,0,1-.24-.276V7.223A1.393,1.393,0,0,1,5,5.862V5.077c-.038.012-.076.019-.115.033a3,3,0,0,1-1.993,0A1.919,1.919,0,0,0,2.5,5.02V6.437a.972.972,0,1,1-.556,0v-1.4A2.328,2.328,0,0,0,0,7.334v.778a.779.779,0,0,0,.778.778H7a.779.779,0,0,0,.778-.778V7.334A2.33,2.33,0,0,0,5.556,5.011Z"
              transform="translate(0)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UserGraduateMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_165" data-name="Group 165" transform="translate(-1072.5 -425)">
        <g id="Component_1_50" data-name="Component 1 – 50" transform="translate(1073 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_104" data-name="Group 104">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(1082 433)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="user-graduate"
              d="M5.6,5.611,3.928,7.288,2.255,5.611A2.355,2.355,0,0,0,0,7.962v.169a.843.843,0,0,0,.842.844H7.015a.843.843,0,0,0,.842-.844V7.962A2.355,2.355,0,0,0,5.6,5.611ZM.238,1.378.351,1.4V2.431a.407.407,0,0,0-.016.7l-.274,1.1c-.03.121.037.246.133.246H.928c.1,0,.163-.125.133-.246l-.274-1.1a.407.407,0,0,0-.016-.7V1.506l1.157.279a2.242,2.242,0,1,0,4.244,1,2.214,2.214,0,0,0-.246-1l1.689-.408a.28.28,0,0,0,0-.554L4.277.016a1.5,1.5,0,0,0-.7,0L.238.823A.281.281,0,0,0,.238,1.378Z"
              transform="translate(1084.756 434.863)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UserFriendsMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_166" data-name="Group 166" transform="translate(-968.5 -425)">
        <g id="Component_1_49" data-name="Component 1 – 49" transform="translate(969 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_103" data-name="Group 103">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(978 433)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="user-friends"
              d="M2.919,35.41a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,2.919,35.41Zm1.168.487H3.961a2.349,2.349,0,0,1-2.083,0H1.752A1.753,1.753,0,0,0,0,37.65v.438a.73.73,0,0,0,.73.731H5.109a.73.73,0,0,0,.73-.731V37.65A1.753,1.753,0,0,0,4.087,35.9ZM7.3,35.41a1.461,1.461,0,1,0-1.46-1.461A1.461,1.461,0,0,0,7.3,35.41Zm.73.487H7.97a1.915,1.915,0,0,1-1.344,0H6.568a1.687,1.687,0,0,0-.847.234,2.229,2.229,0,0,1,.6,1.519v.585c0,.033-.008.065-.009.1H9a.73.73,0,0,0,.73-.731A1.7,1.7,0,0,0,8.028,35.9Z"
              transform="translate(979.857 403.786)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UserCircleMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_167" data-name="Group 167" transform="translate(-864.5 -425)">
        <g id="Component_1_48" data-name="Component 1 – 48" transform="translate(865 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_102" data-name="Group 102">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(874 433)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="user-circle"
              d="M4.753,8a4.753,4.753,0,1,0,4.753,4.753A4.752,4.752,0,0,0,4.753,8Zm0,1.84a1.687,1.687,0,1,1-1.687,1.687A1.687,1.687,0,0,1,4.753,9.84Zm0,6.593a3.673,3.673,0,0,1-2.808-1.307,2.137,2.137,0,0,1,1.888-1.146A.469.469,0,0,1,3.969,14a2.537,2.537,0,0,0,.784.132A2.528,2.528,0,0,0,5.537,14a.469.469,0,0,1,.136-.021,2.137,2.137,0,0,1,1.888,1.146A3.673,3.673,0,0,1,4.753,16.433Z"
              transform="translate(875.849 426.849)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TreeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_168" data-name="Group 168" transform="translate(-760.5 -425)">
        <g id="Component_1_47" data-name="Component 1 – 47" transform="translate(761 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_101" data-name="Group 101">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(770 433)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="tree"
              d="M7.593,7.59l-1.6-1.816h.614a.456.456,0,0,0,.417-.262.443.443,0,0,0-.066-.483L5.389,3.2h.58a.455.455,0,0,0,.418-.273A.447.447,0,0,0,6.3,2.448L4.09.09a.33.33,0,0,0-.468,0L1.41,2.448a.447.447,0,0,0-.085.483.455.455,0,0,0,.419.273h.58L.755,5.029a.443.443,0,0,0-.066.483.456.456,0,0,0,.417.262h.614L.119,7.59a.444.444,0,0,0-.071.487.465.465,0,0,0,.421.266H3.214v.491l-.608.972a.321.321,0,0,0,.287.465H4.818a.321.321,0,0,0,.287-.465L4.5,8.834V8.343H7.243a.465.465,0,0,0,.421-.266A.444.444,0,0,0,7.593,7.59Z"
              transform="translate(772.781 433.936)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ToolboxMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_169" data-name="Group 169" transform="translate(-656.5 -425)">
        <g id="Component_1_46" data-name="Component 1 – 46" transform="translate(657 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_100" data-name="Group 100">
          <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" transform="translate(666 433)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="toolbox"
              d="M9.265,35.394l-.834-.841a.587.587,0,0,0-.417-.174H7.078V32.892A.888.888,0,0,0,6.193,32H3.244a.888.888,0,0,0-.885.892v1.487H1.424a.588.588,0,0,0-.417.174l-.834.841A.6.6,0,0,0,0,35.814v1.538H2.359v-.3a.3.3,0,0,1,.295-.3h.59a.3.3,0,0,1,.295.3v.3H5.9v-.3a.3.3,0,0,1,.295-.3h.59a.3.3,0,0,1,.295.3v.3H9.438V35.814A.6.6,0,0,0,9.265,35.394ZM5.9,34.379H3.539V33.189H5.9Zm1.18,3.865a.3.3,0,0,1-.295.3h-.59a.3.3,0,0,1-.295-.3v-.3H3.539v.3a.3.3,0,0,1-.295.3h-.59a.3.3,0,0,1-.295-.3v-.3H0v1.784a.592.592,0,0,0,.59.595H8.848a.592.592,0,0,0,.59-.595V37.947H7.078Z"
              transform="translate(668.026 402.857)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TicketMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_170" data-name="Group 170" transform="translate(-552.5 -425)">
        <g id="Component_1_45" data-name="Component 1 – 45" transform="translate(553 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_98" data-name="Group 98">
          <g id="Group_97" data-name="Group 97" transform="translate(562 433)">
            <rect id="Rectangle_32" data-name="Rectangle 32" width="13" height="13" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="ticket"
              d="M9.541,66.387V64.8a.8.8,0,0,0-.8-.8H.8a.8.8,0,0,0-.8.8v1.591a.8.8,0,0,1,.8.8.8.8,0,0,1-.8.8v1.591a.8.8,0,0,0,.8.8H8.746a.8.8,0,0,0,.8-.8V67.978a.8.8,0,0,1,0-1.591Z"
              transform="translate(563.857 371.786)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TelescopeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_171" data-name="Group 171" transform="translate(-448.5 -425)">
        <g id="Component_1_44" data-name="Component 1 – 44" transform="translate(449 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_96" data-name="Group 96" transform="translate(-1)">
          <g id="Group_99" data-name="Group 99">
            <rect id="Rectangle_32" data-name="Rectangle 32" width="14" height="14" transform="translate(458 433)" fill="#ff00f5" opacity="0" />
          </g>
          <g>
            <path
              id="telescope"
              d="M6.189,1.513,1.208,3.969a.276.276,0,0,0-.147.345l.142.347L.16,5.1a.264.264,0,0,0-.141.343l.326.8a.259.259,0,0,0,.34.142l1.043-.436.142.347a.271.271,0,0,0,.346.139l2.066-.716.01.012L3.521,8.061a.265.265,0,0,0,.036.237.26.26,0,0,0,.211.109h.274a.261.261,0,0,0,.247-.18L4.975,6.15a1.146,1.146,0,0,0,.463,0l.686,2.077a.261.261,0,0,0,.247.18h.274A.26.26,0,0,0,6.856,8.3a.265.265,0,0,0,.036-.237L6.12,5.723a1.177,1.177,0,0,0,.258-.731s0,0,0-.006L7.46,4.61ZM5.206,5.386a.394.394,0,1,1,.39-.394.392.392,0,0,1-.39.394ZM10.392,3.56,9,.162A.259.259,0,0,0,8.658.02l-1.909.8a.264.264,0,0,0-.141.343L8,4.559a.259.259,0,0,0,.34.142l1.909-.8a.264.264,0,0,0,.141-.343Z"
              transform="translate(460 436)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SunMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_172" data-name="Group 172" transform="translate(-344.5 -425)">
        <g id="Component_1_43" data-name="Component 1 – 43" transform="translate(345 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_87" data-name="Group 87">
          <g id="Group_94" data-name="Group 94" transform="translate(354 433)">
            <g id="Group_86" data-name="Group 86">
              <rect id="Rectangle_31" data-name="Rectangle 31" width="13" height="13" fill="#ff00f5" opacity="0" />
            </g>
            <path
              id="sun"
              d="M16.529.241l.487,1.187a.344.344,0,0,0,.5.162L18.609.914a.388.388,0,0,1,.582.421l-.306,1.246A.343.343,0,0,0,19.193,3l1.283.095a.387.387,0,0,1,.222.682l-.982.829a.342.342,0,0,0,0,.523l.982.829a.387.387,0,0,1-.222.682l-1.283.095a.343.343,0,0,0-.308.423l.306,1.246a.388.388,0,0,1-.582.421l-1.094-.675a.344.344,0,0,0-.5.162L16.529,9.5a.389.389,0,0,1-.719,0l-.487-1.187a.344.344,0,0,0-.5-.162l-1.094.675a.388.388,0,0,1-.582-.421l.306-1.246a.343.343,0,0,0-.308-.423l-1.283-.095a.387.387,0,0,1-.222-.682l.982-.829a.342.342,0,0,0,0-.523l-.982-.829a.387.387,0,0,1,.222-.682L13.147,3a.343.343,0,0,0,.308-.423l-.306-1.246a.388.388,0,0,1,.582-.421l1.094.675a.344.344,0,0,0,.5-.162L15.81.241a.389.389,0,0,1,.719,0Zm2.236,4.63a2.6,2.6,0,1,0-2.6,2.588A2.595,2.595,0,0,0,18.766,4.871Zm-.611,0A1.985,1.985,0,1,1,16.17,2.892,1.984,1.984,0,0,1,18.155,4.871Z"
              transform="translate(-9.631 1.872)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const StarOfLifeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_173" data-name="Group 173" transform="translate(-240.5 -425)">
        <g id="Component_1_42" data-name="Component 1 – 42" transform="translate(241 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_85" data-name="Group 85">
          <g id="Group_90" data-name="Group 90" transform="translate(250 433)">
            <rect id="Rectangle_30" data-name="Rectangle 30" width="13" height="13" fill="#ff00f5" opacity="0" />
            <path
              id="star-of-life"
              d="M9.281,6.589,6.609,5.044,9.281,3.5A.316.316,0,0,0,9.4,3.068l-.63-1.092a.315.315,0,0,0-.43-.115L5.665,3.406V.315A.315.315,0,0,0,5.35,0H4.091a.315.315,0,0,0-.315.315V3.406L1.1,1.861a.315.315,0,0,0-.43.115L.045,3.068A.316.316,0,0,0,.16,3.5L2.832,5.044.16,6.589a.316.316,0,0,0-.115.431l.63,1.092a.315.315,0,0,0,.43.115L3.776,6.682v3.09a.315.315,0,0,0,.315.315H5.35a.315.315,0,0,0,.315-.315V6.682L8.337,8.227a.314.314,0,0,0,.43-.115L9.4,7.02a.315.315,0,0,0-.115-.431Z"
              transform="translate(1.855 1.857)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SpaMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_174" data-name="Group 174" transform="translate(-136.5 -425)">
        <g id="Component_1_41" data-name="Component 1 – 41" transform="translate(137 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_84" data-name="Group 84" transform="translate(1)">
          <g id="Group_91" data-name="Group 91" transform="translate(146 433)">
            <rect id="Rectangle_29" data-name="Rectangle 29" width="12" height="12" fill="#ff00f5" opacity="0" />
            <path
              id="spa"
              d="M10.394,35.193a5.556,5.556,0,0,0-3.912,1.659,5.169,5.169,0,0,0-1.215,1.9,5.169,5.169,0,0,0-1.215-1.9A5.556,5.556,0,0,0,.141,35.193.146.146,0,0,0,0,35.349a5.809,5.809,0,0,0,1.624,3.983,4.624,4.624,0,0,0,3.644,1.616,4.623,4.623,0,0,0,3.644-1.616,5.809,5.809,0,0,0,1.624-3.983A.146.146,0,0,0,10.394,35.193ZM5.267,37.4a5.385,5.385,0,0,1,.806-1.01,5.543,5.543,0,0,1,1.1-.9,6.764,6.764,0,0,0-1.769-3.442.205.205,0,0,0-.277,0,6.764,6.764,0,0,0-1.77,3.439,5.445,5.445,0,0,1,1.083.887A5.534,5.534,0,0,1,5.267,37.4Z"
              transform="translate(0.308 -30.229)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SnowflakeMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_175" data-name="Group 175" transform="translate(-32.5 -425)">
        <g id="Component_1_40" data-name="Component 1 – 40" transform="translate(33 425)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_83" data-name="Group 83">
          <g id="Group_92" data-name="Group 92" transform="translate(42 433)">
            <rect id="Rectangle_28" data-name="Rectangle 28" width="13" height="13" fill="#ff00f5" opacity="0" />
            <path
              id="snowflake"
              d="M9.469,6.422a.513.513,0,0,0,.057-.361.506.506,0,0,0-.6-.394L7.065,6.2,5.62,5.45,7.065,4.7l1.861.533a.511.511,0,0,0,.21-1L8.126,4.082l1.13-.659a.514.514,0,0,0,.185-.7.5.5,0,0,0-.691-.187L7.62,3.2l.375-.96a.512.512,0,0,0-.325-.644.5.5,0,0,0-.637.328L6.56,3.815l-1.285.75v-1.5L6.662,1.7A.515.515,0,0,0,6.624.983a.5.5,0,0,0-.714.038l-.636.808V.511a.506.506,0,1,0-1.012,0V1.829l-.636-.808A.5.5,0,0,0,2.913.983a.515.515,0,0,0-.038.722L4.263,3.066v1.5l-1.285-.75L2.5,1.921a.5.5,0,0,0-.637-.328.512.512,0,0,0-.325.644l.375.96L.787,2.538A.5.5,0,0,0,.1,2.725a.514.514,0,0,0,.185.7l1.13.659L.4,4.234a.511.511,0,0,0,.21,1L2.472,4.7l1.445.75L2.472,6.2.611,5.666a.511.511,0,0,0-.21,1l1.011.152-1.13.659a.514.514,0,0,0-.185.7.5.5,0,0,0,.691.187L1.917,7.7l-.375.96a.514.514,0,0,0,.043.414.5.5,0,0,0,.919-.1l.473-1.894,1.285-.75v1.5L2.875,9.2a.515.515,0,0,0,.038.722.5.5,0,0,0,.714-.038l.636-.808v1.318a.506.506,0,1,0,1.012,0V9.071l.636.808a.5.5,0,0,0,.714.038A.515.515,0,0,0,6.662,9.2L5.274,7.834v-1.5l1.285.75.473,1.894a.5.5,0,0,0,.637.328.512.512,0,0,0,.325-.644L7.62,7.7l1.13.659a.5.5,0,0,0,.691-.187.514.514,0,0,0-.185-.7l-1.13-.659,1.011-.152a.5.5,0,0,0,.333-.244Z"
              transform="translate(1.857 0.929)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UsersMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_176" data-name="Group 176" transform="translate(-32.5 -528)">
        <g id="Component_1_52" data-name="Component 1 – 52" transform="translate(33 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_108" data-name="Group 108">
          <rect id="Rectangle_36" data-name="Rectangle 36" width="13" height="13" transform="translate(42 536)" fill="#ff00f5" opacity="0" />
          <g id="Group_89" data-name="Group 89" transform="translate(43.88 538.821)">
            <g id="Group_106" data-name="Group 106" transform="translate(0 0)">
              <g id="Group_107" data-name="Group 107" transform="translate(0 0)">
                <path
                  id="users"
                  d="M1.435,34.873a.958.958,0,1,0-.957-.958A.958.958,0,0,0,1.435,34.873Zm6.7,0a.958.958,0,1,0-.957-.958A.958.958,0,0,0,8.133,34.873Zm.478.479H7.655a.954.954,0,0,0-.674.278A2.189,2.189,0,0,1,8.1,37.267H9.09a.478.478,0,0,0,.478-.479v-.479A.958.958,0,0,0,8.611,35.352Zm-3.827,0A1.676,1.676,0,1,0,3.11,33.676,1.674,1.674,0,0,0,4.784,35.352Zm1.148.479H5.808a2.31,2.31,0,0,1-2.048,0H3.636a1.723,1.723,0,0,0-1.722,1.724v.431a.718.718,0,0,0,.718.718H6.937a.718.718,0,0,0,.718-.718v-.431A1.723,1.723,0,0,0,5.932,35.831Zm-3.344-.2a.954.954,0,0,0-.674-.278H.957A.958.958,0,0,0,0,36.309v.479a.478.478,0,0,0,.478.479h.985A2.194,2.194,0,0,1,2.588,35.63Z"
                  transform="translate(0 -32)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const UtensilsMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_177" data-name="Group 177" transform="translate(-136.5 -528)">
        <g id="Component_1_53" data-name="Component 1 – 53" transform="translate(137 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_109" data-name="Group 109">
          <rect id="Rectangle_37" data-name="Rectangle 37" width="13" height="13" transform="translate(146 536)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="utensils"
              d="M3.646.265a21.44,21.44,0,0,1,.282,2.259A1.849,1.849,0,0,1,2.72,4.358l.226,4.175a.422.422,0,0,1-.421.444H1.4a.422.422,0,0,1-.421-.444l.226-4.175A1.848,1.848,0,0,1,0,2.524,21.376,21.376,0,0,1,.282.265c.056-.356.794-.361.84.019V2.76c.023.06.265.056.281,0,.025-.444.139-2.441.14-2.486.058-.365.784-.365.84,0,0,.047.116,2.043.14,2.486.016.056.26.06.281,0V.284C2.849-.094,3.589-.091,3.646.265Zm2.09,5.01L5.473,8.521a.421.421,0,0,0,.419.456h.982a.42.42,0,0,0,.421-.421V.419A.421.421,0,0,0,6.874,0C5.427,0,2.992,3.129,5.736,5.275Z"
              transform="translate(148.715 537.811)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const WaterMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_178" data-name="Group 178" transform="translate(-240.5 -528)">
        <g id="Component_1_54" data-name="Component 1 – 54" transform="translate(241 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_110" data-name="Group 110">
          <rect id="Rectangle_38" data-name="Rectangle 38" width="13" height="13" transform="translate(250 536)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="water"
              d="M9.474,69.434a1.948,1.948,0,0,1-.976-.386.654.654,0,0,0-.812,0,2.113,2.113,0,0,1-2.456-.025.626.626,0,0,0-.787.03A2.114,2.114,0,0,1,2,69.025a.636.636,0,0,0-.794.034,1.912,1.912,0,0,1-.973.377A.262.262,0,0,0,0,69.7v.542a.266.266,0,0,0,.281.269,3.031,3.031,0,0,0,1.338-.436,3.234,3.234,0,0,0,3.236,0,3.234,3.234,0,0,0,3.236,0,3.118,3.118,0,0,0,1.333.434.266.266,0,0,0,.281-.269v-.532A.27.27,0,0,0,9.474,69.434Zm0-2.425a1.948,1.948,0,0,1-.976-.386.654.654,0,0,0-.812,0A2.113,2.113,0,0,1,5.23,66.6a.626.626,0,0,0-.787.03A2.114,2.114,0,0,1,2,66.6a.636.636,0,0,0-.794.034,1.912,1.912,0,0,1-.973.377A.262.262,0,0,0,0,67.276v.542a.266.266,0,0,0,.281.269,3.031,3.031,0,0,0,1.338-.436,3.235,3.235,0,0,0,3.236,0,3.235,3.235,0,0,0,3.236,0,3.118,3.118,0,0,0,1.333.434.266.266,0,0,0,.281-.269v-.532A.27.27,0,0,0,9.474,67.01Zm0-2.425A1.963,1.963,0,0,1,8.5,64.2a.654.654,0,0,0-.812,0,2.113,2.113,0,0,1-2.456-.025.626.626,0,0,0-.787.03A2.114,2.114,0,0,1,2,64.176a.636.636,0,0,0-.794.034,1.912,1.912,0,0,1-.973.377A.262.262,0,0,0,0,64.851v.542a.266.266,0,0,0,.281.269,3.031,3.031,0,0,0,1.338-.436,3.235,3.235,0,0,0,3.236,0,3.235,3.235,0,0,0,3.236,0,3.118,3.118,0,0,0,1.333.434.266.266,0,0,0,.281-.269v-.532A.27.27,0,0,0,9.474,64.585Z"
              transform="translate(251.737 474.833)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const WifiMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_179" data-name="Group 179" transform="translate(-344.5 -528)">
        <g id="Component_1_55" data-name="Component 1 – 55" transform="translate(345 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="Group_111" data-name="Group 111">
          <rect id="Rectangle_39" data-name="Rectangle 39" width="13" height="13" transform="translate(354 536)" fill="#ff00f5" opacity="0" />
          <g id="Group_7" data-name="Group 7" transform="translate(355.281 538.784)">
            <path
              id="wifi"
              d="M10.437,34.219a7.147,7.147,0,0,0-10.353,0,.307.307,0,0,0-.006.415l.563.613a.25.25,0,0,0,.368.007,5.9,5.9,0,0,1,8.5,0,.25.25,0,0,0,.368-.007l.563-.613a.307.307,0,0,0-.006-.415Zm-5.176,3.56a1.161,1.161,0,0,0,0,2.312,1.161,1.161,0,0,0,0-2.312Zm3.331-1.51a4.712,4.712,0,0,0-6.663,0,.305.305,0,0,0-.009.418l.566.614a.251.251,0,0,0,.362.014,3.454,3.454,0,0,1,4.824,0,.251.251,0,0,0,.362-.014l.566-.614A.305.305,0,0,0,8.592,36.269Z"
              transform="translate(-0.001 -32)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const StarShootingMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_180" data-name="Group 180" transform="translate(-448.5 -528)">
        <g id="Component_1_56" data-name="Component 1 – 56" transform="translate(449 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="star-shooting-solid" transform="translate(104)">
          <rect id="Rectangle_39" data-name="Rectangle 39" width="13" height="13" transform="translate(354 536)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="star-shooting-solid-2"
              data-name="star-shooting-solid"
              d="M6.031,3.751l.221.221a.313.313,0,0,0,.442,0L9.911.755a.313.313,0,0,0,0-.442L9.69.092a.313.313,0,0,0-.442,0L6.031,3.309a.313.313,0,0,0,0,.442ZM4.689,1.784a.313.313,0,0,0,.442,0L6.16.755a.313.313,0,0,0,0-.442L5.939.092a.313.313,0,0,0-.442,0L4.468,1.121a.313.313,0,0,0,0,.442Zm5,2.059a.313.313,0,0,0-.442,0L8.219,4.872a.313.313,0,0,0,0,.442l.221.221a.313.313,0,0,0,.442,0L9.911,4.505a.313.313,0,0,0,0-.442ZM7.117,5.222l-2.047-.3-.916-1.86a.448.448,0,0,0-.8,0l-.916,1.86-2.047.3a.449.449,0,0,0-.248.766L1.62,7.433,1.268,9.477a.448.448,0,0,0,.651.473l1.833-.965,1.833.965a.448.448,0,0,0,.651-.473l-.35-2.043L7.367,5.988A.45.45,0,0,0,7.117,5.222Z"
              transform="translate(355.988 537.427)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SackDollarMarker = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="43.714" viewBox="0 0 32 43.714" fill={props.fillColor ? props.fillColor : '#c80000'}>
      <defs>
        <filter id="Path_567" x="0" y="1.669" width="32" height="42.045" filterUnits="userSpaceOnUse">
          <feOffset dy="3" input="SourceAlpha" />
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feFlood floodOpacity="0.161" />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_181" data-name="Group 181" transform="translate(-552.5 -528)">
        <g id="Component_1_57" data-name="Component 1 – 57" transform="translate(553 528)">
          <rect id="Rectangle_40" data-name="Rectangle 40" width="31" height="42" fill="#c62e2e" opacity="0" />
          <g transform="matrix(1, 0, 0, 1, -0.5, 0)" filter="url(#Path_567)">
            <path
              id="Path_567-2"
              data-name="Path 567"
              d="M1774.585,1211.644a8.374,8.374,0,0,1-.677,3.617l-7.461,15.621a2.466,2.466,0,0,1-.974,1.049,2.69,2.69,0,0,1-2.755,0,2.342,2.342,0,0,1-.952-1.049l-7.483-15.621a8.379,8.379,0,0,1-.676-3.617,10.5,10.5,0,0,1,20.994,0Z"
              transform="translate(-1748.1 -1197.14)"
              stroke="#fff"
              strokeWidth="2"
            />
          </g>
        </g>
        <g id="sack-dollar-solid" transform="translate(208)">
          <rect id="Rectangle_39" data-name="Rectangle 39" width="13" height="13" transform="translate(354 536)" fill="#ff00f5" opacity="0" />
          <g>
            <path
              id="sack-dollar-solid-2"
              data-name="sack-dollar-solid"
              d="M3.48,1.741H5.8l.86-1.29A.29.29,0,0,0,6.42,0H2.862a.29.29,0,0,0-.241.451Zm2.321.58H3.48C-.19,4.414,0,7.194,0,7.545A1.878,1.878,0,0,0,1.989,9.286h5.3A1.878,1.878,0,0,0,9.282,7.545C9.282,7.2,9.452,4.4,5.8,2.321ZM4.957,7.363v.314a.158.158,0,0,1-.158.156H4.483a.158.158,0,0,1-.158-.156V7.36a1.146,1.146,0,0,1-.62-.221A.155.155,0,0,1,3.694,6.9l.233-.219a.162.162,0,0,1,.2-.014.485.485,0,0,0,.253.073h.555a.246.246,0,0,0,.233-.258.252.252,0,0,0-.174-.248L4.1,5.974a.885.885,0,0,1-.624-.848.875.875,0,0,1,.843-.881V3.929a.158.158,0,0,1,.159-.156H4.8a.157.157,0,0,1,.158.156v.318a1.145,1.145,0,0,1,.62.221.155.155,0,0,1,.012.236l-.231.221a.162.162,0,0,1-.2.014A.486.486,0,0,0,4.9,4.866H4.349a.246.246,0,0,0-.233.258.253.253,0,0,0,.174.248l.889.264a.884.884,0,0,1-.222,1.728Z"
              transform="translate(356.169 538.167)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
